/**
 * Determines if a story's content should be mature-gated based on the
 * user's qualification and story data.
 */
const isMatureGatedContent = (isLoggedin, isMatureStory, countryCode) => {
  return (
    !isLoggedin && isMatureStory && isUserInMatureGatedCountries(countryCode)
  );
};

const MATURE_GATED_COUNTRIES = ["TR"]; // Turkey

const isUserInMatureGatedCountries = countryCode => {
  if (!countryCode) {
    return true; // If we don't have a country code, gate the content by default
  }
  return !!MATURE_GATED_COUNTRIES.includes(countryCode);
};

module.exports = {
  isMatureGatedContent
};
